import type { IxfWatchlistV1OfacSdnKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../../util/routing/entity-paths';

export const OFAC_SDN_BASE_PATH = getResolvedPath('/clearing/compliance/ofac/sdn');

export const getOfacSdnPath: EntityPathBuilder<IxfWatchlistV1OfacSdnKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return OFAC_SDN_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.ofacSdnId) {
        return undefined;
      }

      return getResolvedPath(`${OFAC_SDN_BASE_PATH}/$ofacSdnId`, context.keys);
    }
  }
};

export function getOfacSdnDetailPath(ofacSdnId: string | undefined) {
  if (!ofacSdnId) {
    return undefined;
  }

  return getOfacSdnPath({ kind: 'detail', keys: { ofacSdnId } });
}
